import { Modal, Text } from '@nimbus-ds/components';
import { Trans } from 'react-i18next';
import { CancelAndConfirmButtons, Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface ConfirmTransferStockAndDeleteLocationModalProps {
  locationName: string;
  destinationName: string;
  onConfirm: () => void;
  onClose: () => void;
}

function ConfirmTransferStockAndDeleteLocationModal({
  locationName,
  destinationName,
  onConfirm,
  onClose,
}: Readonly<ConfirmTransferStockAndDeleteLocationModalProps>) {
  const t = useTranslationShipping();

  return (
    <>
      <Modal.Header
        title={t(
          'locations.deleteSteps.confirmTranseferStockAndDeleteLocation.title',
          {
            name: locationName,
          },
        )}
      />
      <Modal.Body padding="none">
        <Text>
          <Trans
            t={t}
            i18nKey="locations.deleteSteps.confirmTranseferStockAndDeleteLocation.description"
            values={{ destinationName }}
            components={{ bold: <strong /> }}
          />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Stack spacing="base" justify="flex-end">
          <CancelAndConfirmButtons
            appearance="danger"
            onCancel={onClose}
            onConfirm={onConfirm}
            confirmText={t(
              'locations.deleteSteps.confirmTranseferStockAndDeleteLocation.confirm',
            )}
          />
        </Stack>
      </Modal.Footer>
    </>
  );
}

export default ConfirmTransferStockAndDeleteLocationModal;
